<script lang="ts">
    import type {MessagePhoto} from "./Types";
    import FormattedText from "./FormattedText.svelte";
    import Photo from "./Photo.svelte";

    export let entity: MessagePhoto
    export let isChannel: boolean
    export let telegramUserId: string
    export let telegramChatId: string
    export let telegramMessageId: string
</script>
<FormattedText entity={entity.caption}/>
<Photo entity={entity.photo} {isChannel} {telegramUserId} {telegramChatId} {telegramMessageId}/>
